"use client";

import React, { useEffect, useState } from "react";
import { House, Recycle, MapPin, Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  id: 1,
  value: 10,
  suffix: "X",
  label: "Performance Boost",
  icon: MapPin
}, {
  id: 2,
  value: 99.9,
  suffix: "%",
  label: "Uptime Reliability",
  icon: Star
}, {
  id: 3,
  value: 24,
  suffix: "/7",
  label: "AI Security Monitoring",
  icon: Recycle
}, {
  id: 4,
  value: 50,
  suffix: "k+",
  label: "Sites Optimized",
  icon: House
}];
function StatCard({
  stat,
  index
}: {
  stat: typeof stats[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.5
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const duration = 2000;
    const end = stat.value;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isVisible, stat.value]);
  const Icon = stat.icon;
  return <div data-section-id="225004" data-index={index} ref={ref} className="group relative flex flex-col items-center justify-center overflow-hidden rounded-4xl border-t-4 border-primary bg-card p-8 text-center shadow-none transition-all hover:scale-[1.02]">
      <div className="absolute inset-0 translate-y-full bg-primary/5 transition-transform duration-500 ease-in-out group-hover:translate-y-0" />
      
      <div className="relative z-10 mb-6 rounded-xl bg-primary/10 p-4">
        <Icon className="size-8 text-primary" strokeWidth={2} />
      </div>
      
      <div className="relative z-10 mb-2 flex items-center font-default text-4xl font-bold text-primary md:text-5xl">
        {count.toLocaleString()}
        <span>{stat.suffix}</span>
      </div>
      
      <div className="relative z-10 font-mono text-sm font-semibold uppercase tracking-widest text-foreground md:text-base">
        {stat.label}
      </div>
    </div>;
}
export default function ByTheNumbers() {
  return <section id="performance-by-the-numbers" className="bg-background text-foreground">
      <div className="bg-muted py-20 lg:py-32">
        <div className="container mx-auto px-4">
          <div className="mx-auto mb-16 max-w-3xl text-center">
            <h2 className="mb-4 font-default text-3xl font-bold uppercase tracking-tight text-foreground md:text-5xl">
              The Speed is in the <span className="text-primary">Numbers</span>
            </h2>
            <p className="font-default text-muted-foreground">
              Experience the agility of Werkys with AI-powered performance that never sleeps.
            </p>
          </div>
          
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {stats.map((stat, i) => <StatCard key={stat.id} stat={stat} index={i} />)}
          </div>
        </div>
      </div>
    </section>;
}